// Mobile navigation logic
export default function() {
  const menu = document.querySelector('.c-menu');

  // Toggle header nav
  function toggleMenu(selector) {
    const onClick = () => {
      if (menu) {
        menu.classList.toggle('c-menu--open');
      }
    };
    const elms = document.querySelectorAll(selector);
    elms.forEach((elm) => { elm.addEventListener('click', onClick); });
  }

  toggleMenu('.js-nav-toggle');
  toggleMenu('.c-nav__link');


  if (menu) {
    menu.addEventListener('click', (el) => {
      if (el.target === menu) {
        menu.classList.toggle('c-menu--open');
      }
    })
  }
}
